import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'globot-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
})
export class UploadFileComponent {
  @Output() nextEvent = new EventEmitter<void>();
  @Output() backEvent = new EventEmitter<void>();
  @Output() fileUploaded = new EventEmitter<string>();

  @Input() titleExtension: string = '';
  @Input() newBot: boolean = true;

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef<HTMLInputElement>;

  isDragOver = false;
  hasError: boolean = false;
  isMobile = window.innerWidth < 768;
  fileName: string = '';

  constructor(private readonly messageService: MessageService) {}

  next(): void {
    this.nextEvent.emit();
  }

  back(): void {
    this.backEvent.emit();
  }

  onFileDropped(event: any) {
    event.preventDefault();
    this.isDragOver = false;
    const files = event.dataTransfer.files;
    this.handleFileUpload(files);
  }

  onDragOverArea(event: any) {
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeaveArea(event: any) {
    event.preventDefault();
    this.isDragOver = false;
  }

  openFileInput(): void {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: any): void {
    const files = event.target.files;
    this.handleFileUpload(files);
  }

  private handleFileUpload(files: any): void {
    if (!files || files.length === 0) {
      return;
    }

    const file = files[0];
    this.fileName = file.name;
    const fileExtension = file.name.split('.').pop() || '';

    if (fileExtension != '' && this.isExtensionAllowed(fileExtension)) {
      this.hasError = false;
      this.fileUploaded.emit(files);
    } else {
      this.hasError = true;
      console.error('El archivo seleccionado no tiene una extensión permitida.');
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'El archivo seleccionado no tiene una extensión permitida.',
      });
    }
  }

  private isExtensionAllowed(extension: string): boolean {
    if (!this.titleExtension) {
      return true;
    }

    const allowedExtensionsArray = this.titleExtension
      .split(',')
      .map((ext) => ext.trim().toLowerCase());
    const fileExtension = extension.toLowerCase();

    return allowedExtensionsArray.includes(fileExtension);
  }
}
